import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, errMsg } from "@/lib/api";

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email, website });
      setDone(true);
      setEmail("");
      toast.success("You're subscribed!");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div data-testid="newsletter-signup">
      <p className="eyebrow mb-2">Newsletter</p>
      <p className="mb-3 text-sm text-[#5C5850]">Seasonal specials and project tips. No spam.</p>
      {done ? <p className="text-sm font-semibold text-green-700" data-testid="newsletter-success">Thanks for subscribing!</p> : (
        <form onSubmit={submit} className="flex gap-2">
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="newsletter-email-input"
            className="h-10 min-w-0 flex-1 rounded-full border border-[#DDE2EA] bg-white px-4 text-sm outline-none focus:border-[#0E1F3F]" />
          <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={website} onChange={(e) => setWebsite(e.target.value)} />
          <button data-testid="newsletter-submit-btn" className="h-10 rounded-full bg-[#0E1F3F] px-4 text-sm font-semibold text-white hover:bg-[#F2B91C] hover:text-[#0E1F3F]">Join</button>
        </form>
      )}
    </div>
  );
};
